import React from 'react';
import ErrorNotification from './ErrorNotification.mjs';
import { StyledWrapper, StyledInputWithButton, StyledInput, StyledPlaceholder, StyledSubmitButton } from './InputWithButton.styles.mjs';
import { useTheme } from 'styled-components';

const InputWithButton = ({ buttonText, buttonAriaLabel, disabled, errorMessage, placeholder, className, onChange, onSubmit }) => {
    const theme = useTheme();
    return (React.createElement(StyledWrapper, null,
        React.createElement(StyledInputWithButton, null,
            React.createElement(StyledInput, { required: true, disabled: disabled, type: "text", placeholder: "", onChange: onChange }),
            React.createElement(StyledPlaceholder, null, placeholder),
            React.createElement(StyledSubmitButton, { ariaLabel: buttonAriaLabel, disabled: disabled, type: "button", className: className, hoverColor: theme.colors.white, onClick: onSubmit }, buttonText),
            React.createElement(ErrorNotification, { errorMessage: errorMessage }))));
};

export { InputWithButton as default };
//# sourceMappingURL=InputWithButton.mjs.map
